import { Provinces } from '../../../constants/Provinces';
import { CountryListInput } from '../../../helpers/CountryListInput';
import { FieldTypes } from '../../../components/FormBuilder';
import { IndustryTypes } from '../../../constants/IndustryTypes';

export const businessDetailsKeys = [
  'businessType',
  'unitNumber',
  'street',
  'suburb',
  'postalCode',
  'province',
  'country',
  'industry',
  'buildingType',
  'name'
  // 'sharedDirectors',
  // 'sharedBusinessDirectors'
];

export const formInitialValues = {
  regNumber: '',
  buildingType: '',
  unitNumber: '',
  street: '',
  suburb: '',
  postalCode: '',
  province: '',
  category: '',
  name: '',
  vatNumber: '',
  landline: '',
  website: '',
  tradingAs: '',
  country: '',
  building: '',
  sharedDirectors: '',
  sharedBusinessDirectors: ''
};

export const postalCode = {
  placeholder: 'Postal code',
  name: 'postalCode',
  type: 'text',
  inputMode: 'numeric',
  disabled: false,
  dark: false,
  hideUnderline: true
};

export const registrationNumber = {
  type: 'text',
  inputMode: 'text',
  placeholder: 'Business registration number',
  name: 'regNumber',
  disabled: false,
  dark: false,
  hideUnderline: true
};

export const buildingTypes = {
  placeholder: 'Choose building type',
  name: 'buildingType',
  options: [
    { value: 'House', label: 'House' },
    { value: 'Flat/Apartment', label: 'Flat/Apartment' },
    { value: 'Townhouse/Security Estate', label: 'Townhouse/Security Estate' },
    { value: 'Office', label: 'Office' }],
  scrollToTop: false
};

export const unitNumber = {
  placeholder: 'Unit or house number',
  name: 'unitNumber',
  type: 'text',
  inputMode: 'text',
  disabled: false,
  dark: false,
  hideUnderline: true
};

export const streetName = {
  placeholder: 'Street Name',
  name: 'street',
  type: 'text',
  inputMode: 'text',
  disabled: false,
  dark: false,
  hideUnderline: true
};

export const suburb = {
  placeholder: 'Suburb',
  name: 'suburb',
  type: 'text',
  inputMode: 'text',
  disabled: false,
  dark: false,
  hideUnderline: true
};

export const city = {
  placeholder: 'City',
  name: 'city',
  type: 'text',
  inputMode: 'text',
  disabled: false,
  dark: false,
  hideUnderline: true
};

export const province = {
  placeholder: 'Province',
  name: 'province',
  options: [...Provinces],
  scrollToTop: false
};

export const countryField = {
  placeholder: 'Country',
  name: 'country',
  options: [...CountryListInput],
  scrollToTop: false,
  disabled: true
};

export const name = {
  type: 'text',
  inputMode: 'text',
  placeholder: 'Business name',
  name: 'name',
  disabled: false,
  dark: false,
  hideUnderline: true
};

export const vatNumber = {
  type: 'text',
  inputMode: 'text',
  name: 'vatNumber',
  placeholder: 'VAT number',
  disabled: false,
  dark: false,
  hideUnderline: true
};

export const phoneNumber = {
  type: 'text',
  inputMode: 'text',
  name: 'landline',
  placeholder: 'Business phone number',
  disabled: false,
  dark: false,
  hideUnderline: true
};

export const categoryText = {
  label: 'What category describes your business best?',
  isHelp: true,
  toolTipSubHeading: 'Please select the correct business category. This is important for seamless transacting in your business.',
  toolTipHeading: 'Important information'
};

export const businessText = {
  label: 'What is your business address?',
  isHelp: false

};

export const website = {
  type: 'text',
  inputMode: 'text',
  name: 'website',
  placeholder: 'Website (Optional)',
  disabled: false,
  dark: false,
  hideUnderline: true
};

export const category = {
  placeholder: 'Choose a category',
  name: 'industry',
  options: [...IndustryTypes],
  scrollToTop: false
};
export const tradingAs = '';
export const differentBusinessNameCheckbox = {
  name: 'differentBusinessName',
  label: 'My business has a different trading name',
  variant: 'secondary',
  size: 'md',
  shape: 'square',
  disabled: false
};

export const isPersonalAddressCheckbox = {
  name: 'isPersonalAddress',
  label: 'My business and my residential address are the same',
  variant: 'secondary',
  size: 'md',
  shape: 'square',
  disabled: false
};

// export const sharedDirectors = {
//   label: 'Does this business share directors with a previously added business?',
//   options: ['Yes', 'No'],
//   name: 'sharedDirectors'
// };

export const buildingTypeFields = {
  House: [
    {
      type: FieldTypes.PAIRED_FIELDS,
      fields: [
        {
          type: FieldTypes.INPUT,
          props: {
            name: 'houseUnitNumber',
            placeholder: 'Enter unit or house number',
            type: 'number',
            inputMode: 'numeric',
            disabled: false,
            dark: false,
            hideUnderline: true
          }
        },
        {
          type: FieldTypes.INPUT,
          props: {
            name: 'houseStreet',
            placeholder: 'Enter street name',
            type: 'text',
            inputMode: 'text',
            disabled: false,
            hint: 'Example: 12 Ridge Road',
            dark: false,
            hideUnderline: true
          }
        }
      ]
    }
  ],
  'Flat/Apartment': [
    {
      type: FieldTypes.INPUT,
      props: {
        name: 'flatBuilding',
        placeholder: 'Enter building name',
        type: 'text',
        inputMode: 'text',
        disabled: false,
        dark: false,
        hideUnderline: true
      }
    },
    {
      type: FieldTypes.PAIRED_FIELDS,
      fields: [
        {
          type: FieldTypes.INPUT,
          props: {
            name: 'flatUnitNumber',
            placeholder: 'Enter flat/unit/floor',
            type: 'number',
            inputMode: 'numeric',
            disabled: false,
            dark: false,
            hideUnderline: true
          }
        },
        {
          type: FieldTypes.INPUT,
          props: {
            placeholder: 'Address',
            name: 'flatStreet',
            type: 'text',
            inputMode: 'text',
            hint: 'Example: 12 Ridge Road',
            disabled: false,
            dark: false,
            hideUnderline: true
          }
        }
      ]
    }
  ],
  'Townhouse/Security Estate': [
    {
      type: FieldTypes.INPUT,
      props: {
        name: 'townBuilding',
        placeholder: 'Enter estate name',
        type: 'text',
        inputMode: 'text',
        disabled: false,
        dark: false,
        hideUnderline: true
      }
    },
    {
      type: FieldTypes.PAIRED_FIELDS,
      fields: [
        {
          type: FieldTypes.INPUT,
          props: {
            name: 'townUnitNumber',
            placeholder: 'Enter unit or house number',
            type: 'number',
            inputMode: 'numeric',
            disabled: false,
            dark: false,
            hideUnderline: true
          }
        },
        {
          type: FieldTypes.INPUT,
          props: {
            name: 'townStreet',
            placeholder: 'Enter street name',
            type: 'text',
            inputMode: 'text',
            hint: 'Example: 12 Ridge Road',
            disabled: false,
            dark: false,
            hideUnderline: true
          }
        }
      ]
    }
  ],
  Office: [
    {
      type: FieldTypes.INPUT,
      props: {
        name: 'officeBuilding',
        placeholder: 'Enter building or office park name',
        type: 'text',
        inputMode: 'text',
        disabled: false,
        dark: false,
        hideUnderline: true
      }
    },
    {
      type: FieldTypes.PAIRED_FIELDS,
      fields: [
        {
          type: FieldTypes.INPUT,
          props: {
            name: 'officeUnitNumber',
            placeholder: 'Enter unit or suite number',
            type: 'number',
            inputMode: 'numeric',
            disabled: false,
            dark: false,
            hideUnderline: true
          }
        },
        {
          type: FieldTypes.INPUT,
          props: {
            placeholder: 'Address',
            name: 'officeStreet',
            type: 'text',
            hint: 'Example: 12 Ridge Road',
            inputMode: 'text',
            disabled: false,
            dark: false,
            hideUnderline: true
          }
        }
      ]
    }
  ]
};

export const getFormFields = (businessType, isUnverifiedBusiness, businessList, businessDetails) => {

  if (isUnverifiedBusiness) {
    const unverifiedBusinessFields = [
      {
        type: FieldTypes.INPUT,
        props: {
          ...name,
          disabled: true
        }
      },
      ...(businessType !== 'Sole Proprietorship'
        ? [
          {
            type: FieldTypes.INPUT,
            props: {
              ...registrationNumber,
              disabled: true
            }
          }
        ]
        : (businessType === 'Sole Proprietorship')
          ? [
            {
              type: FieldTypes.INPUT,
              props: {
                ...vatNumber,
                disabled: true
              }
            }
          ]
          : [])
    ];

    return unverifiedBusinessFields;
  }

  const fields = [
    {
      type: FieldTypes.INPUT,
      props: name
    },
    {
      type: FieldTypes.CHECKBOX_WITH_INPUT,
      checkbox: {
        ...differentBusinessNameCheckbox,
        disabled: businessDetails?.businessId && businessDetails?.tradingAs
      },
      conditionalInput: {
        name: 'tradingAs',
        label: 'Business trading name',
        placeholder: 'Enter business trading name',
        disabled: businessDetails?.businessId && businessDetails?.tradingAs
      }
    },
    ...(businessType !== 'Sole Proprietorship'
      ? [
        {
          type: FieldTypes.INPUT,
          props: registrationNumber
        },
        {
          type: FieldTypes.INPUT,
          props: vatNumber
        }
      ]
      : (businessType === 'Sole Proprietorship')
        ? [
          {
            type: FieldTypes.INPUT,
            props: vatNumber
          }
        ]
        : []),

    {
      type: FieldTypes.CATEGORY_WITH_HEADING,
      props: categoryText
    },
    {
      type: FieldTypes.SELECT,
      props: category
    },
    // {
    //   ...(businessList?.length > 0 && businessType !== 'Sole Proprietorship') && {
    //     type: FieldTypes.SHARED_DIRECTOR_RADIO_GROUP,
    //     props: sharedDirectors
    //   }
    // },

    {
      type: FieldTypes.INPUT,
      props: phoneNumber
    },
    {
      type: FieldTypes.INPUT,
      props: website
    },
    {
      type: FieldTypes.CATEGORY_WITH_HEADING,
      props: businessText
    },
    {
      type: FieldTypes.CHECKBOX,
      props: isPersonalAddressCheckbox
    },
    {
      type: FieldTypes.CUSTOM_SELECT,
      props: buildingTypes
    },
    {
      type: FieldTypes.PAIRED_FIELDS,
      fields: [
        {
          type: FieldTypes.INPUT,
          props: suburb
        },
        {
          type: FieldTypes.INPUT,
          props: postalCode
        }
      ]
    },
    {
      type: FieldTypes.PAIRED_FIELDS,
      fields: [
        {
          type: FieldTypes.INPUT,
          props: city
        },
        {
          type: FieldTypes.CUSTOM_SELECT,
          props: province
        }
      ]
    },
    {
      type: FieldTypes.PAIRED_FIELDS,
      fields: [
        {
          type: FieldTypes.SELECT,
          props: countryField
        }
      ]
    },
    {
      type: FieldTypes.DYNAMIC_BUILDING_FIELDS,
      fields: buildingTypeFields
    }
  ];

  return fields;
};